<template>
  <div class="evidenceblock">
    <div class="title">
      <div class="title-left">{{ evidenceData.title }}</div>
      <div class="title-right">
        <z-button v-show="evidenceData.example_title" @click="showModal = true" type="link">查看凭证示例</z-button>
      </div>
    </div>
      <z-field
        darkBg
        v-model="message"
        type="textarea"
        :placeholder="evidenceData.placeholder || '请描述具体问题'"
        rows="3"
        :maxlength="300"
        count-word
        @blur="handleBlur"
      ></z-field>
    <div class="tip" v-html="evidenceData.text"></div>
    <div class="upload">
      <z-upload
        ref="upload"
        :accept="accept"
        v-model="files"
        :max="max"
        btnUploadInfo="上传凭证"
        @file-click="fileClick"
        @file-success="fileSuccess"
        @file-removed="fileRemove"
        @files-added="filesAdded"
        dropOriginFile
        :draggable="false"
        :chooseMediaPhotosParameter="chooseMediaPhotosParameter"
      >
      </z-upload>
    </div>
    <z-action-picker
      v-model="showModal"
      :title="evidenceData.example_title"
      @cancel="showModal = false"
      btn-text="我知道了"
      @confirm="showModal = false"
    >
    <div class="exampletext" v-html="evidenceData.example_text"></div>
    <div class="example">
      <div class="wrap"
        v-for="(item,index) in picExample"
        :key="index+ 'img'"
      >
        <div
          class="img"
          @click="preview(1,item)"
          :style="{backgroundImage: 'url(' + $setPicSize(item) + ')'}"
          >
        </div>
        <div>图片示例</div>
      </div>
      <div class="wrap"
        v-for="(item,index) in videoExample"
        :key="index + 'vid'"
      >
        <div
          class="video"
          @click="preview(2,item)"
        >
          <div class="playerbtn"></div>
        </div>
        <div>视频示例</div>
      </div>
    </div>
    </z-action-picker>
  </div>
</template>

<script>
import { Upload, Field, ActionPicker, ImagePreview } from '@zz-common/zz-ui'
import { setPicSize } from '@zz-common/zz-utils'
export default {
  name: 'EvidenceBlock',
  components: {
    'z-upload': Upload,
    'z-field': Field,
    'z-action-picker': ActionPicker
  },
  props: {
    evidenceData: {
      type: Object,
      default: () => {
        return {
          title: '请填写相关凭证',
          text: '请参考凭证提示，上传问题凭证(图片/视频)',
          placeholder: '请简要描述商品问题与交易经过'
        }
      }
    },
    cache: {
      type: Object,
      default: () => {
        return {
          message: '',
          files: []
        }
      }
    },
    max: {
      type: Number,
      default: 10
    },
    Finished: {
      type: Function,
      default: () => {}
    }, //向外传递数据
    accept: {
      type: String,
      default: 'image/*, video/*'
    }
  },
  inject: ['toggleEvidenceLoading'],
  data() {
    return {
      files: [],
      message: '',
      showModal: false
    }
  },
  created() {
    this.message = this.cache.message
    this.files = this.cache.files
  },
  computed: {
    picExample() {
      return this.evidenceData.example?.split('|') || []
    },
    videoExample() {
      return this.evidenceData.example_vid?.split('|') || []
    },
    chooseMediaPhotosParameter() {
      return {
        videoLength: '120',
        isNeedShowVideo: '0',
        maxCount: String(this.max),
        maxImagesCount: '9',
        maxVideosCount: '1',
        requestId: '1',
        supportEdit: '1',
        businessType: '1',
        isShowVideoList: '1'
      }
    }
  },
  watch: {
    message(_val) {
      this.Finished({
        files: this.files,
        message: this.message
      })
    }
  },
  methods: {
    preview(type, url) {
      if (type == 1) {
        this.$imagePreview({
          images: [url],
          showClose: true,
          showLoading: true
        });
      } else {
        this.$imagePreview({
          videoVos: [{
            auto: false,
            muteBtn: false,
            controls: true,
            videoUrl: url
          }],
          startPosition: 0,
          withVideo: true,
          showClose: true,
          adaptHeight: true,
          adaptApp: true,
          showLoading: true
        });
      }
    },
    fileClick(data) {
      console.log('看看对象', data)
      if (/image/g.test(data.type)) {
        ImagePreview({
          images: [data.url],
          showClose: true,
          showLoading: true
        });
      }
      if (/video/g.test(data.type)) {
        ImagePreview({
          videoVos: [{
            auto: false,
            muteBtn: false,
            controls: true,
            videoUrl: data.url
          }],
          startPosition: 0,
          withVideo: true,
          showClose: true,
          adaptHeight: true,
          adaptApp: true,
          showLoading: true
        });
      }
    },
    filesAdded() {
      this.toggleEvidenceLoading(true)
    },
    fileSuccess() {
      if (this.$refs.upload.isComplete()) {
        this.toggleEvidenceLoading(false)
      }
      console.log('看看文件', {
        files: this.files,
        message: this.message
      })
      this.Finished({
        files: this.files,
        message: this.message
      })
    },
    fileRemove() {
      if (this.$refs.upload.isComplete()) {
        this.toggleEvidenceLoading(false)
      }
      this.Finished({
        files: this.files,
        message: this.message
      })
    },
    $setPicSize(url) {
      const res = setPicSize(url, 300)
      return res || url
    },
    handleBlur() {
      if (this.message.length > 0 && this.message.length < 5) {
        this.$toast('文字描述最少5个字哦')
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import 'index.less';
</style>